import React from 'react'
import { Modal as BModal, Card } from 'react-bootstrap'

export function Modal(props) {
  const { title, show, handleClose, rightTitleLabel, size, headerButtons=[] } = props

  return(
    <BModal size={size} show={show} onHide={handleClose}>
      <Card className="m-0 overflow-y-scroll w-100">
        <Card.Header>
          <div className="d-flex justify-content-between align-items-center">
            <div className="font-weight-bold">{title}</div>
            { rightTitleLabel && <div>{rightTitleLabel}</div>}
            {headerButtons.map((buttoned, index)=>(
              <button 
                key={index}
                onClick={buttoned.handleClick} 
                className="btn btn-primary ml-3 mt-1">{buttoned.label}</button>
            ))}
          </div>
        </Card.Header>
        <Card.Body className="p-4">
          {props.children}
        </Card.Body>
      </Card>
    </BModal>
  )
}

export default Modal